import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { GIFTING_INFO_MODAL } from '../../brands/default/content/components/checkout';
import { EGIFT_INFO_IMG } from '../../config/constants/images';
import ThemeContext from '../../providers/ThemeProvider';
import WowModal from '../WowModal';

export default function GiftingInfoModal({ show, onClose }) {
  const theme = useContext(ThemeContext);

  return (
    <>
      <WowModal
        ariaLabelledBy="id-gifting-modal"
        extraClasses="gifting-modal"
        setShowModal={onClose}
        showModal={show}
        size="lg"
        title={GIFTING_INFO_MODAL.giftingBrand}
        titleClasses="gifting-header"
      >
        <div className="row">
          <span className="col-12 col-sm-12">
            <h3 className="gift__title">
              {GIFTING_INFO_MODAL.eGiftingIncludes}
            </h3>
            <ul className="gift__list">
              <li key={'gift-bullet'}>
                <span className="gift-bullet--pink">
                  {GIFTING_INFO_MODAL.pinkImmediateDelivery}
                </span>{' '}
                {GIFTING_INFO_MODAL.viaEmail}
              </li>
              {GIFTING_INFO_MODAL.eGiftingIncludesBullets.map(
                (bullet, index) => (
                  <li key={`gift-bullet-${index}`}>{bullet}</li>
                ),
              )}
            </ul>
            <img
              alt={GIFTING_INFO_MODAL.eGiftAlt}
              className="gift__img"
              src={EGIFT_INFO_IMG}
            />
          </span>
        </div>
      </WowModal>

      <style jsx>{`
        .gift__title {
          color: ${theme.colors.primary};
          font-size: 22px;
          text-align: center;
          margin-bottom: 10px;
        }
        .gift__list {
          padding: 0 10% 16px 29%;
          font-size: 15px;
        }
        .text-size {
          font-size: 13px;
          list-style: disc;
        }
        .gift-bullet--pink {
          color: ${theme.colors.primary};
        }
        :global(.gifting-header) {
          margin-left: 6%;
          margin-bottom: 3%;
        }
        .gift__img {
          display: block;
          object-fit: cover;
          margin: 0 auto 20px;
          max-width: 100%;
          max-height: 20rem;
        }
        :global(.gifting-modal .modal-dialog) {
          max-width: 700px;
        }
        :global(.gifting-modal .close) {
          opacity: 1;
          color: ${theme.colors.primary};
        }
        :global(.gifting-modal .modal-title) {
          color: ${theme.colors.primary};
          width: 100%;
          text-align: center;
          font-size: 26px;
        }
        :global(.gifting-modal .modal-body) {
          padding: 0px 10px;
        }
      `}</style>
    </>
  );
}

GiftingInfoModal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
};
